export default __webpack_public_path__ + "static/media/thirdparty.7341c1b5.svg";